/* eslint-disable max-len */
import {
  validateDiscPercentajes,
  validateEmailCase,
  validateEmpty,
  validateFloatingState,
  validateId,
  validateLengthId,
  validateNumber,
  validateRucLength,
  validateSQLBoolean,
  validateTextNoAccent,
  validateTextUpperCase,
  validateUpperCaseAndSpecial,
} from '../components/main/form/validations/validations';

const addSolNacValid = (data) => {
  if (data.floatingState === 'S') {
    return [validateEmpty];
  }
  return [];
};

export const formValidations = {
  'documentType': (data) => [validateEmpty],
  'document': (data) => {
    if (data.documentType === 'C') {
      return [validateEmpty, validateUpperCaseAndSpecial, validateId, validateNumber, validateLengthId];
    }
    if (data.documentType === 'R') {
      return [validateEmpty, validateUpperCaseAndSpecial, validateNumber, validateRucLength];
    }
    if (data.documentType === 'P') {
      return [validateEmpty, validateUpperCaseAndSpecial, validateLengthId];
    }
    return [validateEmpty, validateUpperCaseAndSpecial];
  },
  'names': (data) => {
    if (data.documentType === 'R') {
      return [];
    }
    return [validateEmpty, validateTextUpperCase];
  },
  'lastNames': (data) => {
    if (data.documentType === 'R') {
      return [validateEmpty, validateUpperCaseAndSpecial];
    }
    return [validateEmpty, validateTextUpperCase];
  },
  'dealerReservation': (data) => [validateEmpty],
  'adviserCode': (data) => [validateEmpty],
  'clientType': (data) => [validateEmpty],
  'certificate': (data) => {
    if (data.floatingState === 'S') {
      return [validateSQLBoolean];
    }
    return [];
  },
  'discapacityPerc': (data) => {
    if (data.clientType === '001') {
      return [validateEmpty, validateNumber, validateDiscPercentajes];
    }
    return [];
  },
  'hasLegalRepresentative': (data) => addSolNacValid(data),
  'legalRepresentativeType': (data) => {
    if (data.hasLegalRepresentative === 'S') {
      return [validateEmpty];
    }
    return [];
  },
  'legalRepresentativeId': (data) => {
    if (data.hasLegalRepresentative === 'S') {
      if (data.legalRepresentativeType === 'C') {
        return [validateEmpty, validateUpperCaseAndSpecial, validateId, validateNumber, validateLengthId];
      }
      if (data.legalRepresentativeType === 'R') {
        return [validateEmpty, validateUpperCaseAndSpecial, validateNumber, validateRucLength];
      }
      if (data.legalRepresentativeType === 'P') {
        return [validateEmpty, validateUpperCaseAndSpecial, validateLengthId];
      }
      return [validateEmpty, validateUpperCaseAndSpecial];
    }
    return [];
  },
  'legalRepresentativeName': (data) => {
    if (data.hasLegalRepresentative === 'S') {
      if (data.legalRepresentativeType === 'R') {
        return [validateEmpty, validateUpperCaseAndSpecial];
      }
      return [validateEmpty, validateTextUpperCase];
    }
    return [];
  },
  'location': (data) => addSolNacValid(data).concat([validateUpperCaseAndSpecial]),
  'city': (data) => addSolNacValid(data).concat([validateUpperCaseAndSpecial]),
  'province': (data) => addSolNacValid(data).concat([validateUpperCaseAndSpecial]),
  'country': (data) => addSolNacValid(data).concat([validateUpperCaseAndSpecial]),
  'phoneNumber': (data) => addSolNacValid(data).concat([validateUpperCaseAndSpecial, validateNumber]),
  'email': (data) => addSolNacValid(data).concat([validateEmailCase]),
  'businessType': (data) => addSolNacValid(data),
  'contributorCode': (data) => addSolNacValid(data),
  'floatingState': (data) => [validateFloatingState],
  'reserveAdvance': (data) => addSolNacValid(data),
  'solNacNumber': (data) => [],
  'informBillDate': (data) => [],
  'estSaleDate': (data) => [],
  'exonerationPerc': (data) => [],
  'observations': (data) => [validateTextNoAccent],
};
